import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <p>Loading...</p>; // ローディング中の表示
  }

  if (!user) {
    return <Navigate to="/login" />; // 未ログイン時にリダイレクト
  }

  return children; // ログイン済みならコンテンツを表示
};

export default ProtectedRoute;
